function Portfolio() {
  return <div className="bg-green h-screen">Portfolio</div>;
}

export default Portfolio;
